import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/unauthorized")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={3}
      sx={(theme) => ({
        height: "100vh",
        bgcolor: theme.palette.background.default,
        px: 2,
      })}
    >
      <Stack spacing={1} alignItems="center">
        <Typography
          variant="h1"
          sx={(theme) => ({
            fontSize: { xs: "4rem", md: "6rem" },
            fontWeight: 700,
            color: theme.palette.text.primary,
          })}
        >
          403
        </Typography>
        <Typography
          variant="h5"
          sx={(theme) => ({
            color: theme.palette.text.primary,
            fontWeight: 600,
          })}
        >
          {t("unauthorized.title")}
        </Typography>
        <Typography
          variant="body1"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            textAlign: "center",
            maxWidth: 500,
          })}
        >
          {t("unauthorized.message")}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          startIcon={<Icon icon="tabler:home" />}
          onClick={() => navigate({ to: "/home" })}
        >
          {t("unauthorized.backHome")}
        </Button>
        <Button
          variant="outlined"
          startIcon={<Icon icon="tabler:arrow-left" />}
          onClick={() => window.history.back()}
        >
          {t("misc.back")}
        </Button>
      </Stack>
    </Stack>
  );
}
